package ui.campaign.detailv2.widgets

import androidx.compose.foundation.layout.*
import androidx.compose.material3.Icon
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.vector.ImageVector
import androidx.compose.ui.unit.dp
import common.frontend.api.Io.Campaign.WeatherPictograms
import compose.assets.Svg
import compose.assets.svg.*
import playlist.ImplPlaylist
import ui.campaign.detailv2.editor.widget.rememberCampaignDaysAsString
import ui.widget.LazyImage


@OptIn(ExperimentalLayoutApi::class)
@Composable
fun CampaignInfoCardConditionsHeader(
    conditions: ImplPlaylist.Conditions,
    pictograms: List<WeatherPictograms>,
) {
    FlowRow(
        Modifier.fillMaxWidth()
            .wrapContentHeight(Alignment.Top)
            .padding(4.dp),
        horizontalArrangement = Arrangement.spacedBy(8.dp),
        verticalArrangement = Arrangement.spacedBy(4.dp)
    ) {
        HeaderTime(conditions)
        HeaderDate(conditions)
        HeaderWeather(conditions)
        HeaderWeatherPictograms(conditions, pictograms)
    }
}


@Composable
private fun HeaderTime(conditions: ImplPlaylist.Conditions) {
    Row(horizontalArrangement = Arrangement.spacedBy(4.dp)) {
        Icon(
            imageVector = Svg.Timer_edit_outline,
            contentDescription = null,
            modifier = Modifier.align(Alignment.CenterVertically)
        )
        Text(
            text = "${conditions.time.start} - ${conditions.time.end}",
            style = MaterialTheme.typography.bodySmall,
            modifier = Modifier.align(Alignment.CenterVertically)
        )
    }
}

@Composable
private fun HeaderDate(conditions: ImplPlaylist.Conditions) {
    Row(horizontalArrangement = Arrangement.spacedBy(4.dp)) {
        Icon(
            imageVector = Svg.Calendar,
            contentDescription = null,
            modifier = Modifier.align(Alignment.CenterVertically)
        )
        Text(
            text = rememberCampaignDaysAsString(conditions.days),
            style = MaterialTheme.typography.bodySmall,
            modifier = Modifier.align(Alignment.CenterVertically)
        )
    }
}

@OptIn(ExperimentalLayoutApi::class)
@Composable
private fun HeaderWeatherPictograms(conditions: ImplPlaylist.Conditions, weatherPictograms: List<WeatherPictograms>) {
    if (conditions.weather.pictogram.id.isNotEmpty()) {
        FlowRow(
            modifier = Modifier.wrapContentHeight(Alignment.Top),
            horizontalArrangement = Arrangement.spacedBy(4.dp),
            verticalArrangement = Arrangement.spacedBy(4.dp)
        ) {
            conditions.weather.pictogram.id
                .mapNotNull { entry -> weatherPictograms.firstOrNull { it.id == entry } }
                .forEach { entry ->
                    LazyImage(
                        category = "weather",
                        key = entry.name,
                        modifier = Modifier.size(24.dp),
                        alphaBackground = false
                    )
                }
        }
    }

}

@Composable
private fun HeaderWeather(conditions: ImplPlaylist.Conditions) {
    Row(horizontalArrangement = Arrangement.spacedBy(8.dp)) {
        HeaderWeatherSimple(
            icon = Svg.Temperature_celsius,
            enabled = conditions.weather.temperature.enable,
            min = conditions.weather.temperature.min,
            max = conditions.weather.temperature.max,
            unit = "°C"
        )
        HeaderWeatherSimple(
            icon = Svg.Cloud_percent_outline,
            enabled = conditions.weather.humidity.enable,
            min = conditions.weather.humidity.min,
            max = conditions.weather.humidity.max,
            unit = " %"
        )
        HeaderWeatherSimple(
            icon = Svg.Weather_windy,
            enabled = conditions.weather.wind.enable,
            min = conditions.weather.wind.min,
            max = conditions.weather.wind.max,
            unit = " m/s"
        )
    }
}

@Composable
private fun HeaderWeatherSimple(
    icon: ImageVector,
    enabled: Boolean,
    min: Int,
    max: Int,
    unit: String
) {

    if (enabled) {
        Row(horizontalArrangement = Arrangement.spacedBy(4.dp)) {
            Icon(
                imageVector = icon,
                contentDescription = null,
                modifier = Modifier.align(Alignment.CenterVertically)
            )
            Text(
                text = "${min} .. ${max}$unit",
                style = MaterialTheme.typography.bodySmall,
                modifier = Modifier.align(Alignment.CenterVertically)
            )
        }
    }
}